import { render, staticRenderFns } from "./registro_edicion_agrupados.vue?vue&type=template&id=1ac78dcf"
import script from "./registro_edicion_agrupados.vue?vue&type=script&lang=js"
export * from "./registro_edicion_agrupados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports